import request from "@/utils/request";

const obj = {
  agentGetCarTypeByCarportId(carportId) {
    return request.get(
      `/device/carTypeOfCarport/agentGetCarTypeByCarportId/${carportId}`
    );
  },
  agentGetCarportById(params) {
    return request.get(`/device/carTypeOfCarport/agentGetAllCarType`, {
      params,
    });
  },
  agentDelCarType(id) {
    return request.post(`/device/carTypeOfCarport/agentDelCarType/${id}`);
  },
  agentEditCarType(data) {
    return request.post(`/device/carTypeOfCarport/agentEditCarType`, data);
  },
};
export default obj;
